// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2FEKB","col":"CardReaderDesc_col__3rzk6","label":"CardReaderDesc_label__2yyiS"};